const partTypeFilterHelpers = require('public/templates/modules/part_type_filter/utils');

/* global rp$, window */
'use strict';
const {
	prepareFacets,
} = require('public/js/components/search-facets');

const {
	prepareSearchResults,
} = require('public/js/search-helper');

const utils = require('public/js/helpers/utils');

var THE_SCRIPT = function () {
	const $onReady = require('public/js/lib/on-ready');

	/********************************************
	 * Load Javascript for the Banner Vpicker Module
	 * -----------------------------------------
	 * @section product_recommended_js
	 ********************************************/

	(function OemAssembliesModule() {
		$onReady({
			rp$, window,
			label: 'oem_assemblies',
			fn: function () {
				function getAssemblyPanelBody($module, assemblyIndex) {
					return $module.find('.oem-assembly-panel-body[data-assembly-index="' + assemblyIndex + '"]');
				}

				function getAssemblyModule($element) {
					return $element.closest('.oem-assemblies-module');
				}

				function isAssemblyNavigationLocked($module) {
					return $module.length && $module.attr('data-assembly-nav-loading') === '1';
				}

				function setAssemblyNavigationLoadingState($module, isLoading) {
					$module.attr('data-assembly-nav-loading', isLoading ? '1' : '0');
					$module.toggleClass('oem-assemblies-module--loading-panel', isLoading);
					$module.find('.oem-assembly-panel-toggle').prop('disabled', isLoading);
					$module.find('.assembly-thumbnails--rail .assembly-thumbnail')
						.attr('aria-disabled', isLoading ? 'true' : 'false')
						.toggleClass('disabled', isLoading);
				}

				function setActiveAssemblyThumbnail($module, assemblyIndex) {
					const $rail = $module.find('.assembly-thumbnails--rail');
					$rail.find('.assembly-thumbnail').removeClass('active');
					$rail.find('.assembly-thumbnail[data-assembly-index="' + assemblyIndex + '"]').addClass('active');
				}

				function getAssemblyIndexFromUrl() {
					if (!window.URLSearchParams) {
						return null;
					}
 
					const params = new window.URLSearchParams(window.location.search || '');
					const assemblyNumber = parseInt(params.get('assembly'), 10);
					if (!(assemblyNumber >= 1)) {
						return null;
					}

					return assemblyNumber - 1;
				}

				function updateAssemblyUrl(assemblyIndex) {
					if (!window.history || typeof window.history.replaceState !== 'function' || !window.URLSearchParams) {
						return;
					}

					const params = new window.URLSearchParams(window.location.search || '');
					params.set('assembly', String(assemblyIndex + 1));
					const queryString = params.toString();
					const nextUrl = window.location.pathname + (queryString ? '?' + queryString : '') + window.location.hash;
					window.history.replaceState(window.history.state, '', nextUrl);
				}

				let scrollLockRafId = null;

				function scrollToAssemblyPanel($panelBody) {
					let $target = $panelBody.closest('.oem-assembly-panel');
					if (!$target.length) {
						$target = $panelBody;
					}
					if (!$target.length) {
						return;
					}

					if (scrollLockRafId) {
						cancelAnimationFrame(scrollLockRafId);
						scrollLockRafId = null;
					}

					const el = $target[0];
					const $module = $panelBody.closest('.oem-assemblies-module');
					const wrapperHeight = $module.find('.assembly-thumbnails-wrapper').first().outerHeight(true) || 0;
					const desiredViewportTop = wrapperHeight;
					let stableFrames = 0;
					const maxFrames = 60;
					let frameCount = 0;

					function adjustScroll() {
						const currentTop = el.getBoundingClientRect().top;
						const drift = currentTop - desiredViewportTop;

						if (Math.abs(drift) > 1) {
							window.scrollBy({ top: drift, behavior: 'auto' });
							stableFrames = 0;
						} else {
							stableFrames++;
						}

						frameCount++;
						if (stableFrames < 3 && frameCount < maxFrames) {
							scrollLockRafId = requestAnimationFrame(adjustScroll);
						} else {
							scrollLockRafId = null;
						}
					}

					const panelTop = $target.offset().top;
					window.scrollTo({ top: panelTop - desiredViewportTop, behavior: 'auto' });
					scrollLockRafId = requestAnimationFrame(adjustScroll);
				}
				function openAssemblyPanel($module, assemblyIndex, shouldScrollAfterLoad) {
					if (!$module.length) {
						return;
					}

					const $panelBody = getAssemblyPanelBody($module, assemblyIndex);
					if (!$panelBody.length) {
						return;
					}

					if (isAssemblyNavigationLocked($module)) {
						return;
					}

					setActiveAssemblyThumbnail($module, assemblyIndex);
					updateAssemblyUrl(assemblyIndex);

					if (shouldScrollAfterLoad) {
						$panelBody.attr('data-scroll-after-load', '1');
						scrollToAssemblyPanel($panelBody);
					}

					if ($panelBody.hasClass('in')) {
						if ($panelBody.attr('data-is-loaded') === '1') {
							scrollToAssemblyPanel($panelBody);
						}

						return;
					}

					$panelBody.one('shown.bs.collapse.oemAssembliesThumb', function() {
						if ($panelBody.attr('data-is-loaded') === '1') {
							scrollToAssemblyPanel($panelBody);
						}
					});
					$panelBody.collapse('show');
				}

				function bindEvents() {
					rp$(document).off('click.oemAssemblies', '.assembly-thumbnail');
					rp$(document).on('click.oemAssemblies', '.assembly-thumbnail', function(e) {
						const $module = getAssemblyModule(rp$(this));
						if (isAssemblyNavigationLocked($module)) {
							e.preventDefault();
							return;
						}

						e.preventDefault();
						const assemblyIndex = rp$(this).attr('data-assembly-index');
						if (assemblyIndex !== undefined) {
							openAssemblyPanel(getAssemblyModule(rp$(this)), parseInt(assemblyIndex, 10), true);
						}
					});

					rp$(document).off('click.oemAssemblies', '.hotspot-scroll-link, .hotspot-see-more-link');
					rp$(document).on('click.oemAssemblies', '.hotspot-scroll-link, .hotspot-see-more-link', function(e) {
						e.preventDefault();
						rp$('.product-diagram').modal('hide');
						const closestAssembly = rp$(this).closest('.pp-image-container').outerHeight();
						const target = this.hash;
						const $target = (rp$(target).offset().top - (closestAssembly*.5));
						rp$('html, body').stop().animate({'scrollTop': $target}, 900, 'swing');
					});

					rp$(document).off('mouseenter.oemAssemblies', '.hotspot, .part-row');
					rp$(document).on('mouseenter.oemAssemblies', '.hotspot, .part-row', function () {
						const $this = rp$(this);
						const part_group = $this.attr('data-pgr-idx');
						const reference_code = $this.attr('data-reference-code');
						if(part_group && reference_code) {
							if($this.hasClass('hotspot')) {
								rp$('.part-row-'+part_group+'-'+ reference_code).addClass('part-row-highlight');
							}
							rp$(this).addClass('hotspot-highlight-active');
							rp$('.hotspot-'+part_group+'-'+ reference_code).addClass('hotspot-highlight');
						}
						if($this.hasClass('hotspot')) {
							$this.find('.hotspot-menu').show();
						}
					});
					rp$(document).off('mouseleave.oemAssemblies', '.hotspot, .part-row');
					rp$(document).on('mouseleave.oemAssemblies', '.hotspot, .part-row', function () {
						const $this = rp$(this);
						const part_group = $this.attr('data-pgr-idx');
						const reference_code = $this.attr('data-reference-code');
						if(part_group && reference_code) {
							if($this.hasClass('hotspot')) {
								rp$('.part-row-'+part_group+'-'+ reference_code).removeClass('part-row-highlight');
							}
							rp$('.hotspot-'+part_group+'-'+ reference_code).removeClass('hotspot-highlight hotspot-highlight-active');
						}
						if($this.hasClass('hotspot')) {
							$this.find('.hotspot-menu').hide();
						}
					});
					if(window.tracking.google.use_gtag_admind_analytics){
						rp$(document).off('click.oemAssemblies', '.product-title a');
						rp$(document).on('click.oemAssemblies', '.product-title a', function HookProductTitleClick(evt) {
							const product = utils.productTitleEvent( rp$(this).parent().parent() , rp$('.subcategory.active-cat')[0], 'Assemblies');
							window.rp_app.track.track_ec_general('select_item', {
								currency:window.rp_app.cart._currency_code,
								items:utils.convertNamesOfItemsForGA([product])
							});
						});
					}

					rp$(document).off('click.oemAssemblies', '#relatedAssemblies .view-related-assemblies');
					rp$(document).on('click.oemAssemblies', '#relatedAssemblies .view-related-assemblies', function(e) {
						e.preventDefault();
						const $anchor = rp$(this);
						const $assemblies = rp$('#relatedAssemblies .related-assemblies-row');

						$anchor.toggleClass('active');
						$assemblies.slideToggle(function () {
							try {
								window.rp_app.frameHandler.forceCheck();
							} catch (e) {
								// Do nothing.. we're just doing an iframe resize... if we're inside one
							}
						});
					});

				}

				function buildLazyAssemblyUrl(urlTemplate, assemblyIndex) {
					return urlTemplate.replace('__ASSEMBLY_INDEX__', String(assemblyIndex));
				}

				function buildLazyAssemblyLoadingMarkup() {
					const loadingText = (javascriptContent && javascriptContent.loading) || 'Loading';

					const container = document.createElement('div');
					container.className = 'oem-assembly-panel-loading';
					container.setAttribute('role', 'status');
					container.setAttribute('aria-live', 'polite');

					const spinner = document.createElement('span');
					spinner.className = 'oem-assembly-panel-loading-spinner';
					spinner.setAttribute('aria-hidden', 'true');
					container.appendChild(spinner);

					const text = document.createElement('span');
					text.className = 'oem-assembly-panel-loading-text';
					text.textContent = loadingText + '...';
					container.appendChild(text);

					return container;
				}

				function loadLazyAssemblyPanel($panelBody) {
					const $module = $panelBody.closest('.oem-assemblies-module');
					const urlTemplate = $module.find('.oem-assemblies-panels').attr('data-lazy-assembly-url-template');
					const assemblyIndex = parseInt($panelBody.attr('data-assembly-index'), 10);
					const hasNoUrl = !urlTemplate;
					const hasInvalidIndex = assemblyIndex < 0 || isNaN(assemblyIndex);
					const isAlreadyLoaded = $panelBody.attr('data-is-loaded') === '1';
					const isCurrentlyLoading = $panelBody.attr('data-is-loading') === '1';

					if (hasNoUrl || hasInvalidIndex || isAlreadyLoaded || isCurrentlyLoading || isAssemblyNavigationLocked($module)) {
						return;
					}

					setAssemblyNavigationLoadingState($module, true);
					$panelBody.attr('data-is-loading', '1');
					$panelBody.empty().append(buildLazyAssemblyLoadingMarkup());
					rp$.ajax({
						dataType: 'json',
						method: 'GET',
						url: buildLazyAssemblyUrl(urlTemplate, assemblyIndex),
					}).done(function(response) {
						$panelBody.attr('data-is-loaded', '1');
						$panelBody.attr('data-is-loading', '0');
						setAssemblyNavigationLoadingState($module, false);
						$panelBody.html(response.html || '');
						bindEvents();
						if (typeof rp$.fn.add_to_cart === 'function') {
							$panelBody.find('.add-to-cart.enabled').add_to_cart();
						}
						if (typeof rp$.fn.product_quantity === 'function') {
							$panelBody.find('.product-quantity').product_quantity();
						}
						if ($panelBody.attr('data-scroll-after-load') === '1') {
							$panelBody.attr('data-scroll-after-load', '0');
							scrollToAssemblyPanel($panelBody);
						}
					}).fail(function() {
						$panelBody.attr('data-is-loading', '0');
						setAssemblyNavigationLoadingState($module, false);
						$panelBody.collapse('hide');
						rp_app.notify.add_notification({
							message: javascriptContent.search_error,
							type: 'error',
						});
					});
				}

				function initializeLazyAssemblyPanels() {
					rp$(document).off('show.bs.collapse.oemAssemblies', '.oem-assembly-panel-body');
					rp$(document).on('show.bs.collapse.oemAssemblies', '.oem-assembly-panel-body', function() {
						const $panelBody = rp$(this);
						const $module = getAssemblyModule($panelBody);
						let assemblyIndex = $panelBody.attr('data-assembly-index');
						if (assemblyIndex !== undefined) {
							assemblyIndex = parseInt(assemblyIndex, 10);
							setActiveAssemblyThumbnail($module, assemblyIndex);
							updateAssemblyUrl(assemblyIndex);
						}
						loadLazyAssemblyPanel($panelBody);
					});
				}

				function maybeScrollToSelectedAssemblyFromUrl() {
					const assemblyIndex = getAssemblyIndexFromUrl();
					if (assemblyIndex === null) {
						return;
					}

					if ('scrollRestoration' in history) {
						history.scrollRestoration = 'manual';
					}

					rp$('.oem-assemblies-module').each(function() {
						const $module = rp$(this);
						const $panelBody = getAssemblyPanelBody($module, assemblyIndex);
						if (!$panelBody.length || $panelBody.attr('data-is-loaded') !== '1') {
							return;
						}

						setActiveAssemblyThumbnail($module, assemblyIndex);
						scrollToAssemblyPanel($panelBody);
						return false;
					});
				}

				function updateRailArrows(rail) {
					const wrapper = rail.closest('.assembly-thumbnails-wrapper');
					if (!wrapper) {
						return;
					}
					const prev = wrapper.querySelector('.rail-arrow--prev');
					const next = wrapper.querySelector('.rail-arrow--next');
					if (!prev || !next) {
						return;
					}
					const scrollLeft = rail.scrollLeft;
					const maxScroll = rail.scrollWidth - rail.clientWidth;

					prev.style.display = scrollLeft > 1 ? 'flex' : 'none';
					next.style.display = scrollLeft < maxScroll - 1 ? 'flex' : 'none';
				}

				function initializeRailArrows() {
					rp$('.assembly-thumbnails-wrapper').each(function() {
						const wrapper = this;
						const rail = wrapper.querySelector('.assembly-thumbnails--rail');
						if (!rail) {
							return;
						}

						updateRailArrows(rail);

						rail.addEventListener('scroll', function() {
							updateRailArrows(rail);
						});

						const prev = wrapper.querySelector('.rail-arrow--prev');
						const next = wrapper.querySelector('.rail-arrow--next');
						if (!prev || !next) {
							return;
						}

						prev.addEventListener('click', function() {
							rail.scrollBy({ left: -300, behavior: 'smooth' });
						});

						next.addEventListener('click', function() {
							rail.scrollBy({ left: 300, behavior: 'smooth' });
						});
					});
				}

				let stickySentinels = [];

				function initializeStickyWrapperShadow() {
					stickySentinels.forEach(function(s) {
						s.observer.disconnect();
						if (s.el.parentNode) {
							s.el.parentNode.removeChild(s.el);
						}
					});
					stickySentinels = [];

					if (typeof window.IntersectionObserver !== 'function') {
						return;
					}

					rp$('.assembly-thumbnails-wrapper').each(function() {
						const wrapper = this;
						const sentinel = document.createElement('div');
						wrapper.parentNode.insertBefore(sentinel, wrapper);

						const observer = new IntersectionObserver(function(entries) {
							wrapper.classList.toggle('assembly-thumbnails-wrapper--stuck', !entries[0].isIntersecting);
						}, { threshold: 0 });

						observer.observe(sentinel);
						stickySentinels.push({ el: sentinel, observer: observer });
					});
				}

				function initializeOemAssembliesModule() {
					bindEvents();
					initializeLazyAssemblyPanels();
					initializeRailArrows();
					initializeStickyWrapperShadow();
					maybeScrollToSelectedAssemblyFromUrl();
				}

				initializeOemAssembliesModule();

				/* Handle Search Results Request
				.*-----------------------------------------*/
				function HandleSearchResultsRequest(evt) {
					partTypeFilterHelpers.showSpinner();
				}
				rp$(document).off('searchResults:request', HandleSearchResultsRequest);
				rp$(document).on('searchResults:request', HandleSearchResultsRequest);

				/* Handle Search Results Error
				.*-----------------------------------------*/
				function HandleSearchResultsError(evt) {
					rp$('.oem-assemblies-module').overlaySpinner.remove();
					rp_app.notify.add_notification({
						message: javascriptContent.search_error,
						type: 'error',
					});
				}
				rp$(document).off('searchResults:error', HandleSearchResultsError);
				rp$(document).on('searchResults:error', HandleSearchResultsError);

				/* Handle Search Results Response
				.*-----------------------------------------*/
				function HandleSearchResultsResponse(evt, response) {
					var $listingModule = rp$('.oem-assemblies-module');
					$listingModule.overlaySpinner.remove();

					if(response.listings_html) {
						$listingModule.replaceWith(response.listings_html);
						if (typeof rp$.fn.add_to_cart === 'function') {
							rp$('.oem-assemblies-module').find('.add-to-cart.enabled').add_to_cart();
						}
						if (typeof rp$.fn.product_quantity === 'function') {
							rp$('.search-listing-module').product_quantity();
						}
						initializeOemAssembliesModule();
					}

					if(response.mobile_facets || response.desktop_facets) {
						var $addMobile = rp$('.filters-overlay-content').find('.search-facets-module');
						var $addDesktop = rp$('.desktop-search-filters').find('.search-facets-module');
						$addDesktop.replaceWith(response.desktop_facets);
						$addMobile.replaceWith(response.mobile_facets);
						prepareSearchResults(response.use_cfc);
						prepareFacets();
					}

					rp$('.result-count').each(function CountEle_Iterator(/*idx*/) {
						handleNewCount(rp$(this), response.count);
					});
					rp$('.result-ymm-text').html(response.ymm_text);
				}
				rp$(document).off('searchResults:response', HandleSearchResultsResponse);
				rp$(document).on('searchResults:response', HandleSearchResultsResponse);
			},
		});
	})();
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	if (typeof __CURRENT_SCRIPT__ === 'undefined') {
		throw new Error('__CURRENT_SCRIPT__ is not defined');
	}
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
